import { ApiToken } from './'

export class ApiTokenFactory {
  public get(jwt): ApiToken {
    return new ApiToken(jwt)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/api-token/api-token.factory.ts